import React, { useEffect, useState } from 'react';
import { PageTitle, PseudoStates } from '@cordata/buffet';
import { useRouteMatch } from 'react-router-dom';

import { authorizedInstance as axios } from '~/utils';

import PatientsDemographicsForm from '~/components/Patient/Demographics/Form';

const PatientsDemographics = () => {
  const match = useRouteMatch();
  const [data, setData] = useState({});
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/patients/${match.params.patient_id}?include=addresses,insurance-providers,email-addresses`)
      .then(r => r.data)
      .then(r => setData(r))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, []);

  return (
    <>
      <PageTitle>Demographics</PageTitle>

      {!isLoading && !error ? (
        <PatientsDemographicsForm data={data} />
      ) : (
        <PseudoStates isLoading={isLoading} error={error} />
      )}
    </>
  );
};

export default PatientsDemographics;
